import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "constants/index";
import { Button } from "components/ui";

const Cta: React.FC = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700 via-primary-600 to-primary-500" />
      <svg className="absolute -left-24 -top-24 w-[28rem] h-[28rem] opacity-20" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path fill="#99e0e4" d="M47.6,-66.2C62.1,-58.3,74.1,-46,78.1,-31.4C82.1,-16.8,78.1,0.2,71.4,15.7C64.7,31.1,55.3,45.1,42.1,54.3C28.9,63.5,11.9,68,-3.2,72C-18.3,76.1,-36.5,79.6,-49.8,72.7C-63.1,65.8,-71.6,48.5,-72.1,32.1C-72.5,15.7,-64.9,0.2,-58.1,-14.1C-51.3,-28.4,-45.3,-41.5,-35.5,-50.6C-25.6,-59.7,-12.8,-64.8,1.3,-67C15.4,-69.2,30.8,-68.4,47.6,-66.2Z" transform="translate(100 100)" />
      </svg>
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16 text-center">
        <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">Ready to modernize your ID cards?</h3>
        <p className="mt-2 text-sm sm:text-base text-primary-100">Start free in minutes. No credit card required.</p>
        <div className="mt-6">
          <Link to={ROUTES.PRICING} className="inline-block w-full sm:w-auto">
            <Button size="lg" variant="secondary" className="rounded-full px-6 sm:px-8 bg-white text-primary-700 hover:bg-primary-50 w-full sm:w-auto">Get started</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Cta;


